'use client';

import { useRouterI18n } from '@repo-ui/i18n';
import { useEffect } from 'react';

export default function Page() {
  const router = useRouterI18n();

  useEffect(() => {
    router.push('/guide/appl/pers');
  }, [router]);

  return null;
}
